import {Button, Modal, Typography} from '@viptech/react-components'
import {ReactNode} from 'react'
import {Icon} from 'src/common/generics/components/icon/IconBase'
import CloseIcon from 'src/images/closeBlueIcon.svg'

import {FormModalBody, FormModalContent, FormModalFooter, FormModalHeader, FormModalIntro} from './FormModalBase'

export type FormModalProps = {
  isOpen: boolean
  onClose: () => void
  title: string
  titleSize?: string
  subtitle?: string
  description?: string
  width?: string
  bodyGap?: string
  children: ReactNode
  onCancel: () => void
  onSave: () => void
  saveDisabled?: boolean
  isLoading?: boolean
  cancelLabel?: string
  saveLabel?: string
}

export function FormModal({
  isOpen,
  onClose,
  title,
  titleSize = '20px',
  subtitle,
  description,
  width = '500px',
  bodyGap,
  children,
  onCancel,
  onSave,
  saveDisabled = false,
  isLoading = false,
  cancelLabel = 'Cancelar',
  saveLabel = 'Salvar',
}: FormModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      backgroundColor='white'
      width={`min(${width}, calc(100vw - 32px))`}
      padding='0'>
      <FormModalContent>
        <FormModalHeader>
          <Typography variant='p' weight={500} size={titleSize} color='#344054'>
            {title}
          </Typography>
          <Icon src={CloseIcon} cursor='pointer' onClick={onClose} style={{width: '12px'}} />
        </FormModalHeader>

        {(subtitle || description) && (
          <FormModalIntro>
            {subtitle && (
              <Typography variant='span' size='14px' color='#344054'>
                {subtitle}
              </Typography>
            )}
            {description && (
              <Typography variant='span' size='12px' color='#98A2B3'>
                {description}
              </Typography>
            )}
          </FormModalIntro>
        )}

        <FormModalBody $gap={bodyGap}>{children}</FormModalBody>

        <FormModalFooter>
          <Button fontSize='12px' height='38px' width='120px' variant='outlined' color='#8E8E8E' onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            fontSize='12px'
            height='38px'
            width='120px'
            disabledTextColor='#8E8E8E'
            disabled={saveDisabled}
            isLoading={isLoading}
            onClick={() => !isLoading && onSave()}>
            {saveLabel}
          </Button>
        </FormModalFooter>
      </FormModalContent>
    </Modal>
  )
}
